import { globalEnvironment } from 'constants/global.constants';
import { RECAPTCHA_CLIENT_SECRET } from 'constants/api.constants';

export const loadReCaptchaScript = () => {
	const script = document.createElement('script');
	script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_CLIENT_SECRET[globalEnvironment]}`;
	script.async = true;
	document.body.appendChild(script);
};
